export function opacityAsFractionToTransparencyAsPercent (transparencyFactor) {
  if (transparencyFactor == null) {
    return null;
  }
  return 100 - Math.round(transparencyFactor * 100);
}

export function transparencyAsPercentToOpacityAsFraction (transparency) {
  if (transparency == null) {
    return null;
  }
  return (100 - transparency) / 100;
}

export function opacityAsPercentFromFraction (opacity) {
  if (opacity !== null) {
    return opacity * 100;
  }
  return 100;
}
